module.exports = __webpack_public_path__ + "static/media/logo.be6611a3.svg";